import Konva from 'konva';

/**
 * Añade a un Group una etiqueta de valor / PN con estilo unificado:
 * fondo blanco redondeado semiopaco + texto negro en negrita.
 * Centrada en el origen del group receptor.
 */
export function addUnifiedValueLabel(
  group: Konva.Group,
  text: string,
  fontSize: number,
  maxBoxLength: number,
): void {
  const textWidth = Math.max(text.length * fontSize * 0.62, fontSize);
  const padX = fontSize * 0.35;
  const padY = fontSize * 0.2;
  const bgW = Math.min(maxBoxLength * 0.95, textWidth + padX * 2);
  const bgH = fontSize + padY * 2;
  group.add(
    new Konva.Rect({
      x: -bgW / 2,
      y: -bgH / 2,
      width: bgW,
      height: bgH,
      cornerRadius: bgH * 0.35,
      fill: '#ffffff',
      opacity: 0.7,
      stroke: '#00000030',
      strokeWidth: 0.05,
      listening: false,
    }),
  );
  group.add(
    new Konva.Text({
      x: -bgW / 2,
      y: -fontSize / 2,
      width: bgW,
      height: fontSize,
      text,
      fontSize,
      fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
      fontStyle: 'bold',
      fill: '#111111',
      align: 'center',
      verticalAlign: 'middle',
      listening: false,
    }),
  );
}
